function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawMobilePayments = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1038.82 812.78",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 855.54,
    y1: 848.89,
    x2: 855.54,
    y2: 43.61,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), React.createElement("path", {
    d: "M659.06 108.6c-55.23-1.91-107.84-19.75-158.08-39.21s-100-41.12-153.91-51.46c-34.68-6.65-74.33-7.59-102.28 11-26.88 17.89-35.57 48.78-40.24 77.43-3.52 21.56-5.58 44.26 4.05 64.44 6.68 14 18.55 25.79 26.76 39.21 28.56 46.71 8.37 104.3-22.58 149.9-14.52 21.34-31.37 41.75-42.56 64.48s-16.39 48.87-6.59 72.09c9.72 23 32.87 40.32 58 52.49 50.95 24.7 111 31.77 169.51 35.78 129.58 8.86 259.85 5 389.78 1.18 48.08-1.42 96.37-2.86 143.67-10.3 26.27-4.13 53.39-10.68 72.46-26.5 24.21-20.08 30.21-54.09 14-79.27-27.21-42.24-102.45-52.73-121.46-98.06-10.47-24.95.28-52.75 15.49-75.89 32.64-49.64 87.34-93.19 90.22-149.93 2-39-24.32-78-65-96.44-42.62-19.33-101.71-16.9-133.16 15.1-32.41 32.98-89.31 45.66-138.08 43.96z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M503.15 749.75s-46-81.51-115.32-105c-29.09-9.86-54.48-28.4-71.84-53.74a238.81 238.81 0 0 1-21.2-38.12",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M251.21 537.81c7.89 7.66 44.67 15.59 44.67 15.59s-9-36.52-16.92-44.19a19.93 19.93 0 0 0-27.75 28.6zM272.01 603.9c10.8 2.14 46-11.19 46-11.19s-27.43-25.76-38.22-27.9a19.93 19.93 0 1 0-7.76 39.09zM347.77 675.39c10.4-3.6 34-32.87 34-32.87s-36.67-8.39-47.07-4.79a19.93 19.93 0 0 0 13 37.66zM417.27 716.62c10.86-1.79 39.1-26.64 39.1-26.64s-34.73-14.47-45.59-12.68a19.93 19.93 0 0 0 6.49 39.32zM348.66 564.17c0 11-19.91 42.93-19.91 42.93s-19.94-31.91-19.95-42.91a19.93 19.93 0 0 1 39.86 0zM429.33 613.39c-3.29 10.5-31.84 35-31.84 35s-9.48-36.41-6.19-46.91a19.93 19.93 0 1 1 38 11.91zM501.17 671.99c-1.46 10.9-25.46 39.88-25.46 39.88s-15.5-34.28-14-45.19a19.923 19.923 0 1 1 39.49 5.31z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M251.21 537.81c7.89 7.66 44.67 15.59 44.67 15.59s-9-36.52-16.92-44.19a19.93 19.93 0 0 0-27.75 28.6zM272.01 603.9c10.8 2.14 46-11.19 46-11.19s-27.43-25.76-38.22-27.9a19.93 19.93 0 1 0-7.76 39.09zM347.77 675.39c10.4-3.6 34-32.87 34-32.87s-36.67-8.39-47.07-4.79a19.93 19.93 0 0 0 13 37.66zM417.27 716.62c10.86-1.79 39.1-26.64 39.1-26.64s-34.73-14.47-45.59-12.68a19.93 19.93 0 0 0 6.49 39.32zM348.66 564.17c0 11-19.91 42.93-19.91 42.93s-19.94-31.91-19.95-42.91a19.93 19.93 0 0 1 39.86 0zM429.33 613.39c-3.29 10.5-31.84 35-31.84 35s-9.48-36.41-6.19-46.91a19.93 19.93 0 1 1 38 11.91zM501.17 671.99c-1.46 10.9-25.46 39.88-25.46 39.88s-15.5-34.28-14-45.19a19.923 19.923 0 1 1 39.49 5.31z",
    opacity: 0.25
  }), React.createElement("path", {
    d: "M500.5 748.13s-9-93.17-62.87-142.73c-22.6-20.8-38.3-48-43.9-78.24a238.09 238.09 0 0 1-3.93-43.45",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M356.06 452.28c4.11 10.21 34.52 32.36 34.52 32.36s6.55-37.05 2.44-47.26a19.944 19.944 0 0 0-37 14.9zM348.29 521.13c9 6.33 46.57 8.4 46.57 8.4s-14.63-34.66-23.63-41a19.93 19.93 0 1 0-22.94 32.59zM388.57 617.21c11 .92 44.44-16.26 44.44-16.26s-30.13-22.56-41.1-23.45a19.93 19.93 0 1 0-3.34 39.71zM435.41 683.05c10.66 2.76 46.55-8.52 46.55-8.52s-25.89-27.3-36.54-30.06a19.93 19.93 0 0 0-10 38.58zM434.47 515.86c-4.46 10.07-35.6 31.18-35.6 31.18s-5.3-37.25-.85-47.31a19.93 19.93 0 0 1 36.45 16.13zM488.27 593.55c-7.26 8.27-43.29 19.1-43.29 19.1s6.09-37.13 13.35-45.39a19.922 19.922 0 1 1 29.94 26.29zM530.21 676.24c-5.8 9.38-39.44 26.15-39.44 26.15s-.28-37.62 5.48-47a19.945 19.945 0 0 1 34 20.86z",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 597.86,
    cy: 793.45,
    rx: 268.81,
    ry: 19.33,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M1058.7 297.46c.78-2.13-5.07-13.95-5.07-14.53s-6.05-7.17-6.05-10.85-8-11.62-8-11.62-10.73-4.46-11.9-14.15-12.85-9.88-12.88-9.88.05-.89.07-2.22c0-3-.09-8.4-1.44-11.34-2-4.26-6.64-5.62-6.64-5.62s-1.17-7.56-3.51-9.89a11.1 11.1 0 0 1-2.73-10.46c1.17-3.67-1.56-13-7.22-14.33s-12.1-3.49-12.1-3.49-.63.12-1.56.25l-.78-.25a34.3 34.3 0 0 1-4.1.51 5.14 5.14 0 0 1-3.31-1.09c-2-2.13-17.75-6.2-20.68-6.2s-11.32-3.88-11.32-3.88-5.85-4.45-8.38-6.39c-2.36-1.79-6.71-9.06-7.34-10.13l-.08-.14h-.05a35.93 35.93 0 0 1-1.53-4.23c-.09-.3-.16-.6-.24-.9a46.64 46.64 0 0 0 7.26-10c.2-.38.38-.77.57-1.15a4.21 4.21 0 0 0 1.27-.2 5.38 5.38 0 0 0 .51-.2 8.5 8.5 0 0 0 4.14-4.95c.14-.42.26-.85.37-1.28l.09-.43c.07-.29.13-.59.19-.89s.05-.33.08-.5.09-.58.13-.87 0-.33.07-.49c.05-.37.09-.73.14-1.1.16-1.37.32-2.74.61-4.08a.14.14 0 0 1 0-.06c1.16-5.26 4.33-9.7 6.57-14.56.32-.7.62-1.41.9-2.12s.54-1.56.77-2.36c.07-.24.12-.48.19-.72q.22-.88.39-1.77c.05-.25.1-.5.14-.76.14-.8.25-1.61.31-2.42a29.86 29.86 0 0 0-2-13.61c-1.46-3.64-3.64-6.92-5.12-10.55-2.24-5.52-2.83-11.76-5.57-17-4.59-8.81-15.41-13.22-24.3-9.91-4.24 1.58-7.92 4.65-12.23 6-5.76 1.84-11.93.46-17.9-.37s-12.56-.9-17.36 3c-5.53 4.49-7 12.93-12.22 17.85-2.18 2.07-4.89 3.39-7.19 5.3a11.79 11.79 0 0 0-3.61 4.93c0 .14-.09.28-.13.42s-.09.33-.13.5-.07.39-.1.58 0 .27 0 .4a6 6 0 0 0 0 1 8.33 8.33 0 0 0 .16 1 2 2 0 0 0 .07.26 7.71 7.71 0 0 0 .24.82v.15c.11.3.23.59.35.89l.19.43c0 .12.11.24.16.37a23 23 0 0 1 1.81 4.5 5 5 0 0 1-.18 3 9 9 0 0 1-2.16 2.84 40.32 40.32 0 0 0-8.81 14.1c-.22.6-.43 1.2-.63 1.81v.05l.26.07a13.06 13.06 0 0 0 1.71.37c.33 0 .66.08 1 .1a15.2 15.2 0 0 0 4-.3c.34-.07.67-.15 1-.24a23.88 23.88 0 0 0 3.95-1.45v1.85a46.06 46.06 0 0 0 25.6 41.21c.06.43.11.84.17 1.26s.09.71.13 1.06l-.53-.51s-3.51-1.74-6.83 3.3-9.56 7.36-9.56 7.36-35.51 5.62-36.87 10.27l-16.59 1s-5.85.77-6.43 13-3.71 13.37-3.71 13.37-6.83 12-6.24 18.21-5.27 9.3-5.27 9.3l-.78 11s-6.44-1-8.2 6.59-4.87 11-4.87 11-10.74 8.92-11.32 16.47l-6.63 4.07s-15.42-3.49-18.93-9.69l-1.08-1a.75.75 0 0 1-.09-.15.32.32 0 0 0 0 .07c-2.3-2.17-7.2-6.73-6.45-5.68a4.82 4.82 0 0 1 .32 3.12l-1.15-1.27-3.07-3.41s-22.93-26.34-37.56-28.19l-1.11-2.19a2.51 2.51 0 0 0-3.37-1.1l-22.07 11a2.49 2.49 0 0 0-1.12 3.35l2.47 4.85h-.05a.23.23 0 0 0-.1.32l.87 1.71a.24.24 0 0 0 .32.11l.91 1.79a.27.27 0 0 0-.12.36l1.65 3.24a.26.26 0 0 0 .36.12l.67 1.31a.26.26 0 0 0-.11.34l1.68 3.3a.24.24 0 0 0 .34.11l16 31.61a2.52 2.52 0 0 0 3.37 1.11l16.94-8.47.6.44 5 6.43c-.85 2-1.56 4-2.16 5.79a1.54 1.54 0 0 1-.05.17c-.13.38-.25.76-.36 1.12l-.12.38c-.12.37-.23.73-.33 1.07l-.18.64c0 .12-.08.25-.11.37-.55 1.94-.9 3.44-1.09 4.27l-1.29-.4 1.26.54v.2c-.06.26-.08.41-.08.41.38.18.78.35 1.2.52 6.83 3 40.94 17.94 42.69 20.21 1.95 2.52 14.83 9.88 26.54 3.68s14.24-15.69 14.24-15.69 11.32-15.7 11.71-18 9.17-5 9.17-5 .78 26-3.71 35.46-12.88 51.53-12.88 51.53a6.16 6.16 0 0 1 1.66-.1l-.49 2.43a5.54 5.54 0 0 1 2.06 0c-.62 4.77-4.2 27-4.2 27s-1.17 10.08-3.13 13.56-2.14 21.7-2.14 21.7l-3.12 13.18s.41.91 1.18 2.27v.05s3.35 7.44 9 11.61a23.82 23.82 0 0 1-1.57 6c-2 3.87-1.56 9.3-1.56 9.3s-3.31 14.91-2.93 19.18-2.22 14.72-2.22 14.72l-3.51 33.71s-2.34 29.25-1.17 37.2-.78 18.79-.78 18.79 2.34 23.06 1.75 25.57-3.51 13.37-1.75 19.38.78 22.47.78 22.47 1.17 21.71 2.53 28.68-.39 15.89-.39 15.89-1.37 14.92-2 14.92-5.66 10.26 4.68 20.34 3.96 8.5 3.96 8.5-8.2-4.07-7.22 4.26c.92 7.93 2.21 5.86 2.33 5.64l-2 6.37s.51.06 1.37.19l-1.13 1.36a30.79 30.79 0 0 1-3.94 4.08c-2.34 1.74-2.54 5.61-2.54 5.61s-14.43 15.7-27.89 23.64c-7.08 4.18-13.2 7.72-15.86 10.64-2.4 2.63-2 4.76 3 6.41 10.54 3.49 29.07 5.23 42.33.78a49.37 49.37 0 0 0 20.68-13.37s8.4-4.27 16.59-2.72 24.58-9.1 24.58-9.1l-.3-2.75-.87-7.91s-2-2.33-1.37-4.84c.27-1.14-.14-4.08-.67-7-.14-.77-.29-1.53-.44-2.25l1.5-.28s-1.94-9.88 1.57-11.82 2.53-27.32 2.53-27.32-4.49-5.81-6.83-6.78-.2-13 .2-14.53 3.51-31.58 3.51-31.58-1.17-9.49.39-13.56-1.95-19.76-1.95-19.76-1.17-1.94 1-4.27 1.33-22.99 1.33-22.99-.19-10.46-.19-13.18 2.34-12.59 4.48-15.88.79-13.57.79-13.57l.12-.77c0-.29.1-.67.17-1.1l.18-1a146.82 146.82 0 0 1 3.8-16.82c2.54-8.14 5.47-22.47 5.47-22.47L863 504l.21-.56s8.38 15.5 8.38 29.85c0 0 2.16 17.24 1.57 21.89s1.76 26.54 1.76 26.54 2.53 31.38 2.53 32.74 3.12 25.58 5.08 29.27-2 14.91-3.13 16.07.39 29.65.39 29.65-2.93 22.47-3.51 27.12-2.93 22.48-1 29.46 1.17 7.94 1.17 7.94 7 7.17 2.93 7.75-10.33 5.81-7.81 14.14 8.6 20.74 8.6 20.74 1.21-.27 3.23-.68v2.3l.24 11.55s1.36 11 .58 13.57c-.57 1.83-1.35 10.52-1.73 15-.14 1.66-.22 2.77-.22 2.77s0 10.26 21.65 7.17 25.56-11.63 25.56-11.63l.16-1.07c.32-2 1-6.11 1.59-8.42.79-3.11-6.23-17.06-6.23-17.06s-1.18-9.48-3.13-11.62a10.28 10.28 0 0 1-1.57-4.07c-.18-.78-.33-1.59-.46-2.39a17 17 0 0 1 1.44.26s-1.17-6.78 3.33-8.92 3.31-6.58 2.73-8.52 1.75-12.78 1.75-12.78a6.33 6.33 0 0 1 1.56-6.2c2.74-2.72 4.88-21.71 4.88-21.71L936 661s1.37-13-.19-18.22-3.13-15.3-1-18 .2-15.3.2-15.3 0-26.55 2.92-33.13 2-48.25 2-48.25l.77-27.31s6.37-6 4.86-37.48c6.8-.42 14.47-.67 15.63.27 2.14 1.74 16 10.66 24.19 5 1.76-.78 9.75-7.56 9.75-7.56l-3.44-58.09c2.15 3.24 3.45 5.39 3.45 5.39 0-8.14 23-34.49 23-34.49s21.46-27.7 26.14-31 13.85-20.73 13.85-20.73a85.71 85.71 0 0 1 4.69-9.69c2.12-3.51-4.9-12.81-4.12-14.95zm-50.34 20.35c-5.85.58-18.14 13.95-18.34 16.85-.1 1.53-1.39 3.59-2.59 5.21-.09-1.17-.19-2.36-.29-3.57-1.38-17.12-2.86-38-2.18-40 1.17-3.49.77-19.18.77-19.18l.22-.3c3.94 12.16 16.15 26.5 16.15 26.5s2.15 6.2 4.68 6.39 1.58 8.1 1.58 8.1z",
    transform: "translate(-80.59 -43.61)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M614.96 269.77s7.11-37.3 30-37.49l16.72 34.42-11.15 7.69s-24.23.77-35.57-4.62z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M661.68 266.69l-11.15 7.7s-17 .54-29.24-2.46a33.72 33.72 0 0 1-6.33-2.16s0-.2.13-.6a1.21 1.21 0 0 1 0-.14 84.41 84.41 0 0 1 4.33-13.7c.7-1.67 1.5-3.4 2.36-5.12 3.35-6.45 8.06-12.77 14.5-15.9a19.8 19.8 0 0 1 7.63-2h1.02l.36.76 5.66 11.63z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M851.66 421.68s24-2.31 26.15-.58 15.77 10.58 23.84 5 2.69-25 2.69-25.77-.76-28.26-.76-28.26l-14.43-19.42-18.07-34-36.92-3.65 1 54-.19 27.69z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M851.66 421.68s24-2.31 26.15-.58 15.77 10.58 23.84 5 2.69-25 2.69-25.77-.76-28.26-.76-28.26l-14.43-19.42-18.07-34-36.92-3.65 1 54-.19 27.69z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M640.14 231.32s-1.91 23.46-16.53 23.84c0 0-4.14-2.5-9.71-6.66-12.84-9.61-33.22-28.08-27.59-45.26 8.08-24.61 47.3 20.77 47.3 20.77l3 3.38z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M640.14 231.32s-1.91 23.46-16.53 23.84c0 0-4.14-2.5-9.71-6.66l-1.25-1.6a19.09 19.09 0 0 0 8 2.15c3.67.08 7.8-1.28 10.45-6.58a83.76 83.76 0 0 0 4-9.31 27.46 27.46 0 0 0 1.48-5.77z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M633.8 273.81l-3.29-4.23-11.1-14.25-5.64-7.28a19 19 0 0 0 8 2.16c3.67.08 7.8-1.28 10.46-6.59a83.41 83.41 0 0 0 4-9.31c1.83-5.19 1.79-7.86 1.15-8.76s4.08 3.49 6.35 5.64l.08.08c.65.6 1.07 1 1.07 1l.39.78 5.57 11.14.06.47c.51 3.54 2.39 25.97-17.1 29.15z",
    fill: "#e7effd"
  }), React.createElement("path", {
    d: "M748.98 768.75s-16.15 10.58-24.22 9-16.35 2.7-16.35 2.7a48.66 48.66 0 0 1-20.39 13.27c-13.07 4.42-31.33 2.69-41.71-.78-4.92-1.63-5.31-3.75-2.95-6.35 2.63-2.91 8.66-6.42 15.64-10.57 13.26-7.88 27.49-23.46 27.49-23.46s.19-3.84 2.5-5.57a29.84 29.84 0 0 0 3.88-4c2.06-2.44 4-5 4-5l47.5 1.54s.81 3.43 1.44 6.93c.53 2.87.94 5.79.67 6.92-.58 2.49 1.35 4.8 1.35 4.8l.85 7.85zM848.41 782.01c-.57 2.3-1.26 6.43-1.57 8.37-.11.66-.16 1.06-.16 1.06s-3.85 8.46-25.19 11.54-21.34-7.12-21.34-7.12.08-1.1.22-2.75c.37-4.5 1.14-13.11 1.7-14.94.77-2.5-.57-13.46-.57-13.46l-.23-11.46-.16-8 35.38-3.66a67.68 67.68 0 0 0 1.14 7.88 10 10 0 0 0 1.55 4c1.92 2.13 3.08 11.54 3.08 11.54s6.9 13.92 6.15 17z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M744.41 739.52s.81 3.43 1.44 6.93c-5.13.94-27.56 4.83-33.17 2.11-6.34-3.08-20-4.81-20-4.81l.23-.78c2.06-2.44 4-5 4-5zM837.61 749.51c-9-1.52-28.62 2.16-36.36 3.74l-.16-8 35.38-3.66a67.68 67.68 0 0 0 1.14 7.92z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M857.62 458.02l-.77 27.11s1 41.34-1.92 47.88-2.89 32.88-2.89 32.88 1.93 12.5-.19 15.18-.58 12.7 1 17.89.18 18.08.18 18.08l-.38 72.68s-2.11 18.84-4.81 21.54a6.3 6.3 0 0 0-1.53 6.15s-2.31 10.76-1.73 12.69 1.73 6.34-2.69 8.45-3.28 8.85-3.28 8.85c-10.57-2.5-40.56 4.24-40.56 4.24s-6-12.31-8.47-20.58 3.66-13.46 7.69-14-2.88-7.7-2.88-7.7.77-1-1.15-7.88.38-24.62 1-29.23 3.46-26.92 3.46-26.92-1.53-28.26-.38-29.42 5-12.31 3.08-16-5-27.69-5-29-2.5-32.5-2.5-32.5-2.3-21.73-1.73-26.34-1.54-21.72-1.54-21.72c0-14.24-8.26-29.62-8.26-29.62l-.21.55-17.87 47s-2.88 14.22-5.39 22.3a146.13 146.13 0 0 0-3.75 16.69l-.17 1c-.07.43-.13.8-.17 1.08l-.12.78s1.34 10.19-.77 13.46-4.51 13.07-4.51 15.8.18 13.09.18 13.09.78 20.57-1.34 22.88-1 4.23-1 4.23 3.47 15.57 1.93 19.61-.38 13.45-.38 13.45-3.05 29.74-3.39 31.3-2.5 13.46-.2 14.42 6.73 6.73 6.73 6.73 1 25.19-2.49 27.11-1.55 11.73-1.55 11.73-27.87 5.39-34.22 2.31-20-4.81-20-4.81l1.91-6.32c-.11.22-1.38 2.27-2.29-5.6-1-8.27 7.12-4.23 7.12-4.23s6.34 1.54-3.86-8.46-5.19-20.19-4.61-20.19 1.92-14.8 1.92-14.8 1.73-8.85.38-15.77-2.49-28.46-2.49-28.46 1-16.34-.77-22.3 1.15-16.73 1.73-19.24-1.73-25.38-1.73-25.38 1.93-10.76.77-18.64 1.16-36.92 1.16-36.92l3.46-33.46s2.49-10.38 2.11-14.61 2.88-19 2.88-19-.38-5.39 1.54-9.23 2.7-16.53 2.7-16.53l18.46-42.31 9-37.3 122.1-1.15s.45 3.23 1.18 9.11 1.79 14.59 3 25.33c1.06 9.76 2.22 21.24 3.36 34 3.6 40.73-4.09 48.04-4.09 48.04z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M846.28 121.33l-28.47 30.39s-36.52-14.62-32.68-19.62c1.49-1.94 1.25-8 .39-14.78-1.35-10.64-4.23-22.91-4.23-22.91s63.83-10.38 58.44.38c-2 3.94-1.62 8.53-.4 12.77a48 48 0 0 0 6.95 13.77z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M839.73 94.79c-2 3.94-2.9 4.32-1.67 8.56-8.35 9-19 18.75-32.16 18.75a45.53 45.53 0 0 1-20.38-4.78c-1.35-10.64-4.23-22.91-4.23-22.91s63.83-10.38 58.44.38z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M851.66 75.18a45.77 45.77 0 1 1-91.53 0v-.66a45.761 45.761 0 0 1 91.52.66z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M858.29 377.09c-6.06.05-26.25.22-48.81.58h-.27l-7.46.12h-.23c-26.75.43-53.11-4.8-63.69-3.8-22.5 2.11 8.07-20.77 8.07-20.77s24.35 6.5 51.25 5.18l6.47-.33c20.45-1.16 41-3.08 51.72-6.3.75 5.94 1.79 14.62 2.95 25.32z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M858.29 375.94c-6.06 0-26.25.22-48.81.57h-.27l-7.46.13h-.23c-26.75.43-53.11-4.8-63.69-3.81-22.5 2.11 8.07-20.76 8.07-20.76s24.35 6.49 51.25 5.18l6.47-.34c20.45-1.15 41-3.08 51.72-6.3.75 5.94 1.79 14.59 2.95 25.33z",
    fill: "#e3a79f"
  }), React.createElement("path", {
    d: "M793.59 134.02l-35.38 16.54-27.3 211.12s16.15-7.3 25.38-2.69 37.68.39 37.68.39 20.77-1.16 23.85 1.15 39.22-9.61 39.22-9.61 6.54-14.62 1.54-16.92 1.54-25 1.54-25l-3.08-152.29-6.15-19.61-16.54-10-16.94 13.46-8 1.15z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M793.59 131.71l-35.38 16.54-27.3 211.14s16.15-7.31 25.38-2.69 37.68.38 37.68.38 20.77-1.15 23.85 1.15 39.22-9.61 39.22-9.61 6.54-14.61 1.54-16.92 1.54-25 1.54-25l-3.08-152.31-6.15-19.61-16.54-10-16.94 13.47-8 1.14z",
    fill: "#e7effd"
  }), React.createElement("path", {
    d: "M793.01 141.52s10.19 12.11 10 14.61-.57 8.46-.57 8.46l-7.7 15.58s-4.23 19.42-4.23 23.46-6.73 39-6.73 39l-8.07 53.84-10.19 70.57 10.38 17.88 12.31-10.38 16.34-125.76 3.46-24.8s3.65-44.61 3.65-49.22-2.11-16.73-2.11-16.73 2.5-11.54 12.88-14.23-.77-.58-.77-.58l-6-4.81-5.19 2.12s-14.38-4.39-17.46.99z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M791.86 140.39s10.19 12.11 10 14.61-.58 8.46-.58 8.46l-7.69 15.58s-4.18 19.4-4.18 23.43-6.73 39-6.73 39l-8.13 53.92-10.14 70.52 10.39 17.89 12.25-10.41 16.36-125.73 3.46-24.8s3.65-44.61 3.65-49.23-2.11-16.73-2.11-16.73 2.5-11.53 12.88-14.23-.77-.57-.77-.57l-6-4.81-5.11 2.1s-14.47-4.41-17.55 1z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M785.13 120.18s-1.54 1.15-1.92 8.84-5.77 25-5.77 25 20-13.85 30-12.31z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M785.13 117.87s-1.54 1.15-1.92 8.85-5.77 25-5.77 25 20-13.84 30-12.3z",
    fill: "#e7effd"
  }), React.createElement("path", {
    d: "M839.74 114.02l-31.54 27.69s26.54 15.77 30 19.62 6.92-37.69 6.92-37.69z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M840.89 111.72l-31.48 27.67s26.53 15.76 30 19.61 6.93-37.69 6.93-37.69z",
    fill: "#e7effd"
  }), React.createElement("path", {
    d: "M786.28 120.18s-3.46-1.73-6.73 3.27-9.42 7.3-9.42 7.3-35 5.58-36.34 10.19l-16.34 1s-5.77.76-6.35 12.88-3.69 13.24-3.69 13.24-6.73 11.92-6.16 18.07-5.19 9.23-5.19 9.23l24 62.49s.77 25.77-3.66 35.19-12.69 51.15-12.69 51.15 3.47-.77 3.27 1.53-4.23 27.5-4.23 27.5-1.15 10-3.07 13.46-2.12 21.54-2.12 21.54l-3.08 13.07s7.31 16.35 18.46 14 31.47-45.9 31.47-45.9l12.88-47.11 10-46.53 2.88-31.53 4.62-69.8 6.73-46.15s7.46-24.82 4.76-28.09z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M785.13 117.87s-3.46-1.73-6.73 3.27-9.42 7.31-9.42 7.31-35 5.57-36.34 10.19l-16.35 1s-5.77.77-6.34 12.88-3.66 13.27-3.66 13.27-6.73 11.92-6.15 18.07-5.19 9.23-5.19 9.23l24 62.49s.77 25.77-3.65 35.19-12.69 51.15-12.69 51.15 3.46-.77 3.27 1.54-4.23 27.49-4.23 27.49-1.15 10-3.08 13.46-2.11 21.54-2.11 21.54l-3.05 13.03s7.31 16.35 18.46 14 31.34-45.95 31.34-45.95l12.89-47.11 10-46.54 2.89-31.53 4.61-69.8 6.73-46.15s7.49-24.76 4.8-28.03z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M661.68 266.69l-11.15 7.7s-17 .54-29.24-2.46l-6.2-2.76-1.25-.54 1.28.4c6.43 1.91 11.46 1.87 15.39.55 15.78-5.31 14-31.37 13.43-37.27-.06-.59-.1-1-.13-1.12a.32.32 0 0 1 0-.07l.09.15a7.06 7.06 0 0 0 .73 1c.22.25.45.51.7.75l5.57 11.14.06.47z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M700.33 191.51l-5.38 1.54-.77 11s-6.35-1-8.08 6.54-4.8 11-4.8 11-10.58 8.85-11.16 16.34l-6.53 4s-15.2-3.54-18.65-9.65c0 0 6.92 49.61-30 37.49 0 0 41.34 18.08 43.26 20.58s14.62 9.8 26.15 3.65 14.04-15.61 14.04-15.61 11.15-15.58 11.54-17.89 9-5 9-5l16.54-40z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M835.32 137.1l5.57-25.38s2.5 8.27 5 10.19l8.27 6.34s8.27 3.85 11.15 3.85 18.46 4 20.38 6.15 9.62.58 9.62.58 6.34 2.11 11.92 3.46 8.27 10.58 7.11 14.23a11.09 11.09 0 0 0 2.7 10.38c2.3 2.31 3.46 9.81 3.46 9.81a11.25 11.25 0 0 1 6.53 5.57c1.93 4.23 1.35 13.46 1.35 13.46l-28.65 40.38s.38 15.58-.77 19 4 62.3 4 62.3l6 101.14s-7.88 6.73-9.61 7.5-3.47-35.77-3.47-37.11-44.41-66.53-44.41-66.53-6-9.62-6-11.73-5.58-21.54-5.58-21.54l-8.46-37.49z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M930.76 193.54c0 1.32-.07 2.2-.07 2.2l-28.63 40.35s.4 15.57-.76 19c-.67 2 .8 22.7 2.16 39.69 1 12.27 1.88 22.61 1.88 22.61l2.53 42.9 3.42 58.24s-7.88 6.73-9.61 7.5-3.46-35.77-3.46-37.12-44.42-66.52-44.42-66.52-6-9.62-6-11.73-5.57-21.54-5.57-21.54l-8.46-37.5 3.84-114.59 3.27-25.38s4.81 8.27 7.31 10.18 8.26 6.35 8.26 6.35 8.27 3.85 11.16 3.85 18.46 4 20.38 6.15 9.62.58 9.62.58 6.34 2.11 11.91 3.46 8.27 10.58 7.12 14.22a11.09 11.09 0 0 0 2.69 10.39c2.31 2.31 3.46 9.8 3.46 9.8a11.29 11.29 0 0 1 6.54 5.59c1.35 2.99 1.48 8.32 1.43 11.32z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M695.72 705.87c1 0 41.34 1.54 40.57 8.08s-40.57-8.08-40.57-8.08zM704.76 716.83s27.11 4.42 20 8.46-20-8.46-20-8.46zM805.51 701.64s45 3.85 38.27 8.84-22.69 5.77-23.46 6-14.81-14.84-14.81-14.84zM800.13 721.45s25 4.23 25.76 9-25.76-9-25.76-9zM813.97 605.69s22.88 5.38 24.23 9zM725.71 622.23s-11.92 3.46-.38 10.38.38-10.38.38-10.38zM778.59 437.44c1.35 0 22.31-6.92 29.61-3.84s16.35 3.07 16.35 3.07zM781.29 459.39l-.21 1.9-17.87 47s-2.88 14.22-5.39 22.3a146.13 146.13 0 0 0-3.75 16.69l15.87-98.41z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M809.21 376.51l-7.46.13h-.23l-4.37-19.38c2.15-.11 4.3-.22 6.47-.35z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M899.92 353.04l-4.79 3.94-16 13.16s-43.27 23.08-55.19 1.16c-10.51-19.31 38.55-33.1 50.36-36.11 1.61-.41 2.52-.61 2.52-.61z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M715.14 164.02s8.46 3.84 10.38 9.23-10.38-9.23-10.38-9.23zM688.99 221.7s-12.31 15-7.31 20.77 7.31-20.77 7.31-20.77zM908.96 172.48s-11.54 1.15-11.92 11.15zM802.05 330.15c1.15-1.15 27.69-40.38 33.84-36.92zM851.66 75.18a45.6 45.6 0 0 1-5.41 21.6l-.34-.06c-2.9-.61-4.41-4-6.63-6.1a9 9 0 0 0-10.38-1.46 10.56 10.56 0 0 0-5.1 9.87c-1.46-6.16-1-12.71-2.43-18.88s-5.74-12.41-11.63-12.52c-2.54 0-5.51.94-7.34-1-1.11-1.15-1.34-3-2.17-4.35-4.21-6.82-17-3.37-22.26.12-5.06 3.36-11.32 9.08-17.83 12.08a45.761 45.761 0 0 1 91.52.66z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M800.23 61.16c.84 1.39 1.06 3.21 2.17 4.35 1.83 1.9 4.8.93 7.34 1 5.89.1 10.2 6.35 11.63 12.52s1 12.71 2.43 18.87a10.54 10.54 0 0 1 5.11-9.86 9 9 0 0 1 10.37 1.45c2.22 2.11 3.73 5.49 6.63 6.1s5.7-2.17 6.74-5.23 1-6.41 1.66-9.58c1.31-6 5.22-10.91 7.39-16.61a30.12 30.12 0 0 0-.2-21.48c-1.44-3.61-3.59-6.86-5-10.47-2.22-5.48-2.8-11.66-5.49-16.88-4.53-8.74-15.19-13.12-23.95-9.83-4.18 1.57-7.81 4.61-12.05 6-5.69 1.82-11.76.45-17.65-.37s-12.38-.9-17.11 3c-5.44 4.45-6.93 12.82-12 17.71-2.15 2.05-4.82 3.36-7.09 5.26s-4.22 4.72-4 7.81c.34 4 4.24 7.6 2.8 11.29a9.14 9.14 0 0 1-2.13 2.81 40.06 40.06 0 0 0-9.31 15.84c10.29 3.21 21.43-8.13 29.48-13.49 5.21-3.57 18.02-6.98 22.23-.21z",
    fill: "#7c5c5c"
  }), React.createElement("path", {
    d: "M899.92 353.04l-4.79 3.94c-4.22-7-21.55-21.07-21.55-21.07l.75-.72c1.61-.41 2.52-.61 2.52-.61z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M904.54 345.92s-1.72 4.28-3.5 8-3.71 7.06-3.81 4.33c-.19-5.39-22.49-23.47-22.49-23.47l3-2.94 3.51-3.4z",
    fill: "#e7effd"
  }), React.createElement("path", {
    d: "M905.31 317.46l2.53 42.9c-6-9.29-22.37-33.1-32.92-32.33l25.58-29.41a34.41 34.41 0 0 0 2.93-3.77c.98 12.27 1.88 22.61 1.88 22.61z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M904.54 345.92s-1.72 4.28-3.5 8c-6.7-9.19-15.92-20.05-23.28-22.08l3.51-3.4z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M923.77 190.39l6.92 5.38s11.53.2 12.69 9.81 11.73 14 11.73 14 7.88 7.88 7.88 11.53 6 10.2 6 10.77 5.77 12.31 5 14.42 6.15 11.35 4 14.81a84.76 84.76 0 0 0-4.62 9.61s-9 17.31-13.65 20.58-25.76 30.76-25.76 30.76-22.69 26.15-22.69 34.23c0 0-22.12-36.92-35.19-36l25.57-29.42s4.43-4.8 4.62-7.69 12.3-16.15 18.07-16.73c0 0 1-7.88-1.54-8.07s-4.61-6.35-4.61-6.35-16.92-20-17.11-32.69 22.69-38.95 22.69-38.95z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M933.96 208.63s-16.16 11.92-12.69 15.76 12.69-15.76 12.69-15.76zM934.73 257.85s30-9.61 33.07 0zM748.98 768.75s-16.15 10.58-24.22 9-16.35 2.7-16.35 2.7a48.66 48.66 0 0 1-20.39 13.27c-13.07 4.42-31.33 2.69-41.71-.78-4.92-1.63-5.31-3.75-2.95-6.35 11.29 2.25 36.52 6.72 43.32 3.47 8.84-4.23 21.53-13.46 21.53-13.46s16.55-2.31 18.85-2.31c1.64 0 14.41-5.27 21.62-8.3zM846.82 790.39c-.11.66-.16 1.06-.16 1.06s-3.85 8.46-25.19 11.54-21.34-7.12-21.34-7.12.08-1.1.22-2.75c6.75 2.55 21.49 5.42 46.47-2.73zM723.12 206.32s0 43.84-3.75 48.17 3.75-48.17 3.75-48.17zM896.46 220.45l5.57 15.67s2.22-15.38-5.57-15.67z",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M760.5 52.39c1.41-3.61-2.28-7.14-2.76-11a7.24 7.24 0 0 0-.62 3.48c.25 2.91 2.4 5.64 3 8.33a4.55 4.55 0 0 0 .38-.81zM824.32 93.8c-1.38-6.07-1-12.49-2.38-18.55s-5.73-12.42-11.62-12.52c-2.54 0-5.51.93-7.35-1-1.1-1.14-1.33-3-2.16-4.35-4.21-6.82-17-3.36-22.27.13-7.87 5.23-18.67 16.16-28.75 13.68-.49 1.17-.94 2.35-1.31 3.56 10.29 3.21 21.43-8.13 29.48-13.49 5.25-3.49 18.06-7 22.27-.13.84 1.39 1.06 3.21 2.17 4.35 1.83 1.9 4.8.93 7.34 1 5.89.1 10.2 6.35 11.63 12.52s1 12.71 2.43 18.87a10.38 10.38 0 0 1 .52-4.07zM853.23 86.58c-1 3.06-3.79 5.86-6.75 5.23s-4.41-4-6.62-6.1a9 9 0 0 0-10.38-1.45 10.48 10.48 0 0 0-5.1 9.32 10 10 0 0 1 4.53-5.57 9 9 0 0 1 10.37 1.45c2.22 2.11 3.73 5.49 6.63 6.1s5.7-2.17 6.74-5.23a26.16 26.16 0 0 0 1.06-5.52 15.41 15.41 0 0 1-.48 1.77zM862.27 60.39c-2.16 5.7-6.08 10.62-7.38 16.62-.26 1.21-.41 2.45-.56 3.69 1.32-6 5.21-10.88 7.37-16.56a29.7 29.7 0 0 0 1.78-8 29.22 29.22 0 0 1-1.21 4.25z"
  })), React.createElement("rect", {
    x: 682.21,
    y: 246.96,
    width: 0.88,
    height: 7.22,
    rx: 0.38,
    ry: 0.38,
    transform: "rotate(-26.73 550.677 398.383)",
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 652.6,
    y: 255.35,
    width: 0.49,
    height: 2.38,
    rx: 0.21,
    ry: 0.21,
    transform: "rotate(-26.74 520.683 404.259)",
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 654.93,
    y: 259.13,
    width: 0.55,
    height: 4.14,
    rx: 0.24,
    ry: 0.24,
    transform: "rotate(-26.73 523.252 409.009)",
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 657.46,
    y: 264.12,
    width: 0.53,
    height: 4.17,
    rx: 0.23,
    ry: 0.23,
    transform: "rotate(-26.73 525.771 414.032)",
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 660.63,
    y: 238.67,
    width: 29.3,
    height: 59.56,
    rx: 2.24,
    ry: 2.24,
    transform: "rotate(-26.73 543.316 416.266)",
    fill: "#3a3768"
  }), React.createElement("path", {
    d: "M589.33 195.94a1 1 0 0 0-.46 1.41l.1.19a1 1 0 0 1-.47 1.41l-11.09 5.59a1 1 0 0 1-1.41-.46l-.1-.2a1 1 0 0 0-1.41-.46l-2.16 1.08a2 2 0 0 0-.89 2.7l23.59 46.83a2 2 0 0 0 2.7.89l19.35-9.75a2 2 0 0 0 .89-2.69l-23.56-46.84a2 2 0 0 0-2.69-.88z",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 660.13,
    y: 243.75,
    width: 4.09,
    height: 0.83,
    rx: 0.36,
    ry: 0.36,
    transform: "rotate(-26.73 530.214 391.965)",
    fill: "#e6e8ec"
  }), React.createElement("circle", {
    cx: 584.39,
    cy: 199.14,
    r: 0.47,
    fill: "#e6e8ec"
  }), React.createElement("path", {
    d: "M97.01 26.09s97.14-5.86 85.69 62.21c0 0 2.27 12-8.63 17.49 0 0-.17-5-10-3.33a45.23 45.23 0 0 1-10.56.5 21.88 21.88 0 0 1-12.9-5.32s-27.26-11.25-37.89-55.91c0 0-7.85-9.74-7.54-12.24l16.39 7s-5.6 11.83-1.19 21.66c0 0 .53-21.23 3.68-20.73.64.11 8.52 4.1 8.52 4.1s-9.64 20.6-2.37 35.57c0 0-2.76-25.38 5.38-34.08l11.54 6.74s-11.27 21.27-3.63 38.64c0 0-2-26.63 6-37l10.46 8.15s-10.58 21-4.13 35.37c0 0 .84-31 6.39-33.34 0 0 9.15 8.07 10.55 11.38 0 0-7.25 15.22-2.75 23.26 0 0 2.75-20.65 5-20.75 0 0 9.12 13.69 10.07 23.06 0 0-.4-13.95-7.86-24.37 0 0 8.81 1.51 14 7.23 0 0-1.42-9.68-16.21-10.52 0 0-7.53-10.38-9.55-11 0 0 14.71-1.23 23.63 2.72 0 0-7.85-9.13-26.32-5l-10.32-8.42s19.36-2.66 27.57.27c0 0-9.45-8.07-30.36-2.19l-11.26-6.71s16.51-3.56 26.35-2.27c0 0-10.38-5.6-29.64.47l-8-3.61s12.1-2.38 15.64-2.75 3.73-1.36 3.73-1.36a42 42 0 0 0-22.72 2.53s-17.05-6.38-16.76-7.45zM151.41 208.19s43.89-2.65 38.72 28.11c0 0 1 5.43-3.9 7.9 0 0-.08-2.28-4.5-1.51a19.83 19.83 0 0 1-4.77.23 9.91 9.91 0 0 1-5.83-2.4s-12.34-5.1-17.14-25.27c0 0-3.55-4.39-3.41-5.52l7.41 3.16s-2.53 5.34-.54 9.78c0 0 .24-9.59 1.66-9.36.29.05 3.85 1.85 3.85 1.85s-4.35 9.31-1.07 16.07c0 0-1.24-11.46 2.43-15.4l5.22 3.05s-5.13 9.61-1.67 17.51c0 0-.89-12 2.73-16.72l4.73 3.68s-4.78 9.48-1.87 16c0 0 .38-14 2.89-15.07 0 0 4.13 3.64 4.77 5.14 0 0-3.28 6.88-1.25 10.51 0 0 1.25-9.33 2.27-9.37 0 0 4.12 6.18 4.55 10.42 0 0-.18-6.31-3.55-11a12.42 12.42 0 0 1 6.3 3.27s-.64-4.37-7.32-4.75c0 0-3.4-4.69-4.31-5 0 0 6.64-.56 10.67 1.23 0 0-3.54-4.12-11.89-2.25l-4.67-3.81s8.75-1.19 12.46.13c0 0-4.27-3.65-13.71-1l-5.08-3s7.46-1.6 11.9-1c0 0-4.69-2.53-13.39.21l-3.63-1.63s5.46-1.08 7.07-1.25 1.68-.61 1.68-.61a18.93 18.93 0 0 0-10.26 1.14s-7.71-2.99-7.55-3.47zM.83 43.79s43.89-2.64 38.72 28.11c0 0 1 5.44-3.9 7.91 0 0-.08-2.28-4.5-1.51a20.35 20.35 0 0 1-4.77.23 9.92 9.92 0 0 1-5.83-2.41S8.21 71.03 3.41 50.86c0 0-3.55-4.4-3.41-5.53l7.41 3.16s-2.53 5.35-.54 9.79c0 0 .24-9.59 1.66-9.36.29 0 3.85 1.85 3.85 1.85s-4.35 9.31-1.07 16.07c0 0-1.24-11.47 2.43-15.4l5.22 3s-5.09 9.62-1.64 17.46c0 0-.89-12 2.73-16.71l4.73 3.68s-4.78 9.48-1.87 16c0 0 .38-14 2.89-15.06 0 0 4.13 3.64 4.77 5.14 0 0-3.28 6.88-1.25 10.51 0 0 1.25-9.33 2.27-9.38 0 0 4.12 6.19 4.55 10.42 0 0-.18-6.3-3.55-11a12.33 12.33 0 0 1 6.3 3.27s-.64-4.38-7.32-4.76c0 0-3.4-4.69-4.31-5 0 0 6.64-.56 10.67 1.23 0 0-3.54-4.13-11.89-2.25l-4.63-3.77s8.75-1.2 12.46.13c0 0-4.27-3.65-13.71-1l-5.08-3s7.46-1.61 11.9-1c0 0-4.69-2.53-13.39.21l-3.63-1.63s5.47-1.07 7.07-1.24 1.68-.61 1.68-.61a18.93 18.93 0 0 0-10.3 1.08S.7 44.28.83 43.79z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 992.43,
    cy: 736.56,
    rx: 46.39,
    ry: 7.84,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M1011.61 723.74c2-1.85 3.85-4 4.43-6.68s-.56-5.83-3.09-6.8c-2.84-1.08-5.87.89-8.17 2.87s-4.94 4.26-7.95 3.84a12.09 12.09 0 0 0 3.74-11.32 4.66 4.66 0 0 0-1-2.3c-1.57-1.69-4.43-1-6.32.36-6 4.22-7.67 12.37-7.7 19.71-.61-2.65-.1-5.41-.11-8.12s-.76-5.72-3-7.18a9.25 9.25 0 0 0-4.65-1.09c-2.7-.1-5.7.17-7.54 2.14-2.29 2.45-1.7 6.56.3 9.26s5 4.39 7.8 6.25a17.31 17.31 0 0 1 5.58 5.32 5.23 5.23 0 0 1 .41 1h16.91a47.48 47.48 0 0 0 10.36-7.26z",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 57.99,
    cy: 796.03,
    rx: 36.41,
    ry: 6.16,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M73.04 785.96a10.6 10.6 0 0 0 3.48-5.24c.44-2.08-.44-4.58-2.43-5.34-2.23-.85-4.61.69-6.41 2.25s-3.88 3.34-6.24 3a9.49 9.49 0 0 0 2.94-8.88 3.71 3.71 0 0 0-.82-1.81c-1.24-1.32-3.48-.75-5 .29-4.71 3.31-6 9.71-6.05 15.47-.47-2.08-.07-4.24-.09-6.37s-.59-4.5-2.39-5.64a7.23 7.23 0 0 0-3.65-.86c-2.11-.08-4.47.14-5.92 1.68-1.79 1.93-1.33 5.16.23 7.27s3.94 3.45 6.13 4.91a13.57 13.57 0 0 1 4.38 4.18 5 5 0 0 1 .33.74H64.8a36.86 36.86 0 0 0 8.24-5.65z",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 149.78,
    cy: 749.8,
    rx: 36.41,
    ry: 6.16,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M164.84 739.73a10.58 10.58 0 0 0 3.47-5.24c.45-2.08-.44-4.57-2.43-5.33-2.22-.86-4.6.69-6.41 2.25s-3.87 3.34-6.23 3a9.5 9.5 0 0 0 2.93-8.89 3.67 3.67 0 0 0-.82-1.8c-1.23-1.33-3.47-.76-4.95.28-4.71 3.32-6 9.71-6.05 15.47-.48-2.08-.08-4.24-.09-6.37s-.6-4.49-2.39-5.64a7.15 7.15 0 0 0-3.65-.85c-2.12-.08-4.48.13-5.92 1.68-1.8 1.92-1.33 5.15.23 7.27s3.94 3.44 6.13 4.91a13.64 13.64 0 0 1 4.38 4.17 3.94 3.94 0 0 1 .32.75h13.27a36.86 36.86 0 0 0 8.21-5.66z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M563.21 226.59v110.53a11.07 11.07 0 0 1-11.09 11.09h-11.91v-132.7h11.91a11.07 11.07 0 0 1 11.09 11.08z",
    fill: "#c7cce1"
  }), React.createElement("path", {
    d: "M554.29 215.72V348a11.16 11.16 0 0 1-2.17.21h-1.82v-132.7h1.82a11.16 11.16 0 0 1 2.17.21z",
    opacity: 0.2
  }), React.createElement("path", {
    fill: "#dcdfed",
    d: "M467.69 387.64h42.94v344.3h-42.94z"
  }), React.createElement("path", {
    fill: "#c7cce1",
    d: "M452.55 768.7h68.29v9.59h-68.29z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M452.55 768.7h68.29v5.38h-68.29zM467.69 725.13h42.94v6.8h-42.94z"
  }), React.createElement("path", {
    d: "M437.53 726.54h98.32a40.7 40.7 0 0 1 40.7 40.7v6.26H396.83v-6.26a40.7 40.7 0 0 1 40.7-40.7z",
    fill: "#dcdfed"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M467.69 435.04h42.94v41.3h-42.94z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M467.69 432.23h42.94v41.3h-42.94z"
  }), React.createElement("path", {
    fill: "#dcdfed",
    d: "M463.71 433.63h51.39v41.3h-51.39z"
  }), React.createElement("path", {
    d: "M533.76 361.7v17.14a16.08 16.08 0 0 1-16.08 16.08h-57a16.08 16.08 0 0 1-16.08-16.08V361.7a16.07 16.07 0 0 1 16.08-16.06h57a16.07 16.07 0 0 1 16.08 16.06z",
    fill: "#c7cce1"
  }), React.createElement("path", {
    d: "M533.76 361.7v1.75a56.09 56.09 0 0 1-89.19 0v-1.75a16.07 16.07 0 0 1 16.08-16.06h57a16.07 16.07 0 0 1 16.11 16.06z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M437.61 202h103.11a4.53 4.53 0 0 1 4.53 4.53v129a48.61 48.61 0 0 1-48.61 48.61h-14.95a48.61 48.61 0 0 1-48.61-48.61v-129a4.53 4.53 0 0 1 4.53-4.53z",
    fill: "#c7cce1"
  }), React.createElement("path", {
    d: "M456.67 135.37h65a17.26 17.26 0 0 1 17.26 17.26v49.45a6.22 6.22 0 0 1-6.22 6.22h-87.08a6.22 6.22 0 0 1-6.22-6.22v-49.46a17.26 17.26 0 0 1 17.26-17.26z",
    fill: "#c7cce1"
  }), React.createElement("path", {
    opacity: 0.2,
    d: "M451.15 186.53h77.91v5.16h-77.91z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M444.58 218.56h89.17v64.71h-89.17z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M444.58 217.15h89.17v64.71h-89.17z"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("rect", {
    x: 445.08,
    y: 292.95,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79
  }), React.createElement("rect", {
    x: 467.78,
    y: 292.95,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79
  }), React.createElement("rect", {
    x: 490.48,
    y: 292.95,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79
  }), React.createElement("rect", {
    x: 513.19,
    y: 292.95,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79
  }), React.createElement("rect", {
    x: 445.08,
    y: 306.97,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79
  }), React.createElement("rect", {
    x: 467.78,
    y: 306.97,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79
  }), React.createElement("rect", {
    x: 490.48,
    y: 306.97,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79
  }), React.createElement("rect", {
    x: 445.08,
    y: 320.64,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79
  }), React.createElement("rect", {
    x: 467.78,
    y: 320.64,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79
  }), React.createElement("rect", {
    x: 490.48,
    y: 320.64,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79
  }), React.createElement("rect", {
    x: 445.08,
    y: 335.72,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79
  }), React.createElement("rect", {
    x: 467.78,
    y: 335.72,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79
  }), React.createElement("rect", {
    x: 490.48,
    y: 335.72,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79
  }), React.createElement("rect", {
    x: 513.19,
    y: 306.97,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79
  }), React.createElement("rect", {
    x: 514.42,
    y: 319.87,
    width: 17.78,
    height: 25.52,
    rx: 1.97,
    ry: 1.97
  })), React.createElement("rect", {
    x: 445.08,
    y: 291.54,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79,
    fill: "#f2f3f3"
  }), React.createElement("rect", {
    x: 467.78,
    y: 291.54,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79,
    fill: "#f2f3f3"
  }), React.createElement("rect", {
    x: 490.48,
    y: 291.54,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79,
    fill: "#f2f3f3"
  }), React.createElement("rect", {
    x: 513.19,
    y: 291.54,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79,
    fill: "#d44f6a"
  }), React.createElement("rect", {
    x: 445.08,
    y: 305.56,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79,
    fill: "#f2f3f3"
  }), React.createElement("rect", {
    x: 467.78,
    y: 305.56,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79,
    fill: "#f2f3f3"
  }), React.createElement("rect", {
    x: 490.48,
    y: 305.56,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79,
    fill: "#f2f3f3"
  }), React.createElement("rect", {
    x: 445.08,
    y: 319.23,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79,
    fill: "#f2f3f3"
  }), React.createElement("rect", {
    x: 467.78,
    y: 319.23,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79,
    fill: "#f2f3f3"
  }), React.createElement("rect", {
    x: 490.48,
    y: 319.23,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79,
    fill: "#f2f3f3"
  }), React.createElement("rect", {
    x: 445.08,
    y: 334.31,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79,
    fill: "#f2f3f3"
  }), React.createElement("rect", {
    x: 467.78,
    y: 334.31,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79,
    fill: "#f2f3f3"
  }), React.createElement("rect", {
    x: 490.48,
    y: 334.31,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79,
    fill: "#f2f3f3"
  }), React.createElement("rect", {
    x: 513.19,
    y: 305.56,
    width: 20.06,
    height: 7.16,
    rx: 0.79,
    ry: 0.79,
    fill: "#fecb42"
  }), React.createElement("rect", {
    x: 514.42,
    y: 318.47,
    width: 17.78,
    height: 25.52,
    rx: 1.97,
    ry: 1.97,
    fill: "#97d25e"
  }), React.createElement("path", {
    fill: "#c7cce1",
    d: "M489.04 274h9.61v1.15h-9.61zM502.5 274h9.61v1.15h-9.61zM515.96 274h9.61v1.15h-9.61z"
  }));
};

UndrawMobilePayments.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawMobilePayments;